function messageMatchesChatSearch(message, query) {
  const text = String(message || '').toLowerCase();
  const tokens = String(query || '')
    .split(',')
    .map((token) => token.trim())
    .filter(Boolean);
  if (!tokens.length) return true;
  for (const token of tokens) {
    const negated = token.startsWith('!');
    const term = (negated ? token.slice(1) : token).trim().toLowerCase();
    if (!term) continue;
    const found = text.includes(term);
    if (negated ? found : !found) return false;
  }
  return true;
}

const DEFAULT_CONVERSATION_QUERY = '!ledger';

function conversationQueryAfterChatSelect(
  currentQuery,
  previousChatId,
  nextChatId,
  nextIsSystem,
) {
  const sameChat = previousChatId != null && previousChatId === nextChatId;
  if (sameChat) return currentQuery;
  if (nextIsSystem) return DEFAULT_CONVERSATION_QUERY;
  return '';
}

function filterChatMessages(messages, query) {
  const list = Array.isArray(messages) ? messages : [];
  if (!String(query || '').trim()) return list;
  return list.filter((row) =>
    messageMatchesChatSearch(row && row.message, query),
  );
}

module.exports = {
  DEFAULT_CONVERSATION_QUERY,
  conversationQueryAfterChatSelect,
  messageMatchesChatSearch,
  filterChatMessages,
};
